<script>
export default {
  name: "StopTimer",
  props: {
    startTime: String,
    endTime: String,
    withSeconds: Boolean,
    iconSize: {
      type: Number,
      default: 16,
    },
  },
  data() {
    return {
      time: "0h:0m" + (this.withSeconds ? ":0s" : ""),
      intervalId: null,
      minutesLasted: 0,
      hoursLasted: 0,
    };
  },
  computed: {
    timerColor() {
      const hours = Number(this.hoursLasted);
      const minutes = Number(this.minutesLasted);

      if (hours >= 2) {
        return "text-danger";
      }

      if (minutes >= 45 || hours) {
        return "text-orange";
      }

      return "text-blue-grey-darken-2";
    },
  },
  mounted() {
    this.updateTime();
    this.start();
  },
  unmounted() {
    this.stop();
  },
  methods: {
    updateTime() {
      const endTime = this.endTime ? this.$dayjs(this.endTime) : this.$dayjs();
      const secondsDiff = endTime.diff(this.startTime, "second");
      this.hoursLasted = String(Math.floor(secondsDiff / 3600)).padStart(2, "0");
      this.minutesLasted = String(Math.floor((secondsDiff - this.hoursLasted * 3600) / 60)).padStart(2, "0");
      
      const seconds = String(secondsDiff - this.hoursLasted * 3600 - this.minutesLasted * 60).padStart(2, "0");

      this.time = this.hoursLasted + "h:" + this.minutesLasted + "m" + (this.withSeconds ? ":" + seconds + "s" : "");
    },
    start() {
      if (this.endTime) {
        return;
      }
      if (this.intervalId) {
        this.stop();
      }
      this.intervalId = setInterval(this.updateTime, 1000);
    },
    stop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
};
</script>

<template>
  <div :class="timerColor" class="font-size-12 d-flex align-center" data-qa="route-stops-stop-timer">
    <v-icon :size="iconSize" class="mr-1" icon="mdi-timer-outline"></v-icon>
    <div>{{ time }}</div>
  </div>
</template>

<style lang="scss" scoped></style>
